import _ from 'lodash';

const INPUT_TYPES = {
    Choice: 'typelist',
    String: 'text',
    Boolean: 'boolean',
    Integer: 'number',
    Date: 'date'
};

const RADIO_CHOICE_QUESTION_CODES = ['HOPPreQualOccupant'];

export default (question) => {
    return {
        inputCtrlType: {
            get: () => {
                if (_.includes(RADIO_CHOICE_QUESTION_CODES, question.code)) {
                    return INPUT_TYPES.Boolean;
                }
                return INPUT_TYPES[question.questionType];
            }
        }
    };
};